import { render, staticRenderFns } from "./finalInterface.vue?vue&type=template&id=f413cc22&scoped=true&"
import script from "./finalInterface.vue?vue&type=script&lang=js&"
export * from "./finalInterface.vue?vue&type=script&lang=js&"
import style0 from "./finalInterface.vue?vue&type=style&index=0&id=f413cc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f413cc22",
  null
  
)

export default component.exports